"use client";

import { Toaster as ToasterComponent } from "react-hot-toast";

export function Toaster() {
  return <ToasterComponent position="bottom-center" />;
}
